const tour = {
    getlist: 'tour/getlist',
    add: 'tour/add',
    update: 'tour/update',
    remove: 'tour/remove',
    get: 'tour/get',
    getall: 'tour/getall',
    clearcache: 'tour/clear-cache',
    duplicate: 'tour/duplicate',
}
export default tour
